import store from "..";

const getDefaultAuthUser = () => ({
  id: null,
  showAdminPanel: false,
  isFomoViewer: false,
  hasFomoManagementPermission: false,
  isFomoResearcher: false,
  xsrfCookieKey: null
});

const state = () => ({
  authUser: getDefaultAuthUser(),
  isLoggedIn: false,
  modalErrorMessage: '',
  hasModalError: false,
  env: 0,
  customerPortalName: ''
});

const getters = {
  isLoggedIn: (state) => {
    return state.isLoggedIn;
  },
};

const actions = {
};

const mutations = {
  setCustomerPortalName(state, val) {
    state.customerPortalName = val;
  },
  setEnvironment(state, val) {
    state.env = val;
  },
  resetModalError(state) {
    state.modalErrorMessage = '';
  },

  enableModalError(state) {
    state.hasModalError = true;
  },
  disableModalError(state) {
    state.hasModalError = false;
  },
  updateModalError(state, message) {
    state.modalErrorMessage = message;
  },
  setAuthUser(state, user) {
    if (user) {
      state.authUser.id = user.id;
      state.authUser.showAdminPanel = user.showAdminPanel;
      state.authUser.hasFomoManagementPermission = user.hasFomoManagementPermission;
      state.authUser.isFomoViewer = user.isFomoViewer;
      state.authUser.isFomoResearcher = user.isFomoResearcher;
      state.authUser.xsrfCookieKey = user.xsrfCookieKey;
      localStorage.setItem('xsrf-cookie-key', user.xsrfCookieKey);
      
      store.commit('auth/setEnvironment', user.environmentType);
    }
    else
      state.authUser = getDefaultAuthUser();

    state.isLoggedIn = user !== null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
